<template>
    <div class="btn-group">
        <button type="button"
                :class="{'active': !modelValue}"
                class="btn btn-sm btn-default"
                @click.prevent="$emit('update:modelValue', false)">
            {{ l(offLabel) }}
        </button>
        <button type="button"
                :class="{'active': modelValue}"
                class="btn btn-sm btn-default"
                @click.prevent="$emit('update:modelValue', true)">
            {{ l(onLabel) }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },

        offLabel: {
            type: String,
            default: 'NO',
        },

        onLabel: {
            type: String,
            default: 'YES',
        },
    },

    emits: [
        'update:modelValue',
    ],
};
</script>
